<template>
<div 
    class="remote-viewers"
    :class="{ 'animate': doAnimate }"
>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 720 709" style="enable-background:new 0 0 720 709;" xml:space="preserve">
        <circle class="st0" cx="370.3" cy="359.3" r="349.7"/>
        <circle id="badge-bg" class="st1" cx="370.9" cy="359.6" r="324.6"/>
        <polygon id="star-bc" style="animation-delay: 1s;" class="star st2" points="346.4,587.2 352,573.9 357.6,587.2 370.9,592.8 357.6,598.4 352,611.7 346.4,598.4 
            333.1,592.8 "/>
        <polygon id="star-br" style="animation-delay: 3s;" class="star st2" points="562.7,536.6 568.3,523.3 573.9,536.6 587.2,542.2 573.9,547.7 568.3,561.1 562.7,547.7 
            549.4,542.2 "/>
        <polygon id="star-ml" style="animation-delay: 0.5s;" class="star st2" points="94.7,394.8 100.3,381.4 105.9,394.8 119.2,400.3 105.9,405.9 100.3,419.3 94.7,405.9 
            81.4,400.3 "/>
        <polygon id="star-tr" style="animation-delay: 2s;" class="star st2" points="491.1,132.3 499,113.3 506.9,132.3 525.9,140.2 506.9,148.1 499,167.1 491.1,148.1 
            472.1,140.2 "/>
        <g id="star-large" class="star">
            <path class="st2" d="M360.8,181.9l-11.2-54.1l-24.7-10.3l24.7-10.3l11.2-55.5l10.2,55.5l24.7,10.3L371,127.7L360.8,181.9z
                M337.1,117.4l16.6,6.9l6.9,33.2l6.3-33.1l16.6-6.9l-16.6-6.9l-6.2-33.9l-6.8,33.9L337.1,117.4z"/>
        </g>
        <g id="grid">
            <polygon class="st3" points="159.7,229.6 560,196.5 560,485.4 159.7,561 	"/>
            <polygon class="st3" points="220.4,168.9 220.4,438.2 488.3,624.3 493,258.7 	"/>
            <line class="st3" x1="356.7" y1="213.8" x2="346.3" y2="525.7"/>
            <polygon class="st3" points="81.7,307.6 250.3,495.1 682.1,413.2 453.6,271.3 	"/>
            <line class="st3" x1="225.6" y1="293.6" x2="490.5" y2="449.5"/>
            <line class="st3" x1="159.7" y1="394.3" x2="560" y2="337.4"/>
        </g>
        <path class="skull right" id="skull-bg" d="M330.2,447.2c16.8,15.8,40.9,23.6,63.8,20.5c11.1-1.5,22.4-5.7,29.4-14.4c6.1-7.6,8.2-17.6,9.3-27.3
            c2-17.7,1.1-35.8-2.6-53.2c-2.1-9.7-5.1-19.4-10.4-27.8c-5.3-8.4-13.2-15.5-22.7-18.4c-10.6-3.2-22.2-1.1-32.6,2.7
            c-19.6,7.1-37,19.9-50,36.3c-5.4,6.8-10.9,14-10.3,23c0.6,9.2,3.1,19.6,6.3,28.2C314.5,428.3,321.3,438.9,330.2,447.2z"/>
        <g class="skull right" id="skull-bot">
            <path d="M433.7,445.5c-0.9-2.1-2.4-3.2-3.7-3.8c0.5-1.8,0.9-4.9-0.8-7.1c-1.8-2.3-5.2-2.9-10.2-2c-12.4,2.4-27.7,5.3-66.5-3.2
                l-0.4-0.1l-0.4,0.1c-0.5,0.2-4.6,1.6-5.9,4.4c-0.2,0.4-0.3,0.9-0.3,1.3c-1.8,0.1-4.9,0-7.8-1.9c-3.2-2.1-5.2-5.8-6.2-11l-3.5-19.2
                l-8.6,3.4l-16.6-21.1l-0.2-0.2c-0.2-0.2-5.4-4.7-10.5-3.7c-2.6,0.5-4.7,2.4-6.2,5.4l-0.1,0.2c-1.1,3.5-1.5,11.3,4.8,15.2
                c6.7,4.1,21.8,30.1,18.9,48.3c-0.4,1.3-0.7,6.5,13.6,11.3c12.6,4.2,18,6,19.1,6.3c2.6,1.7,26.8,17.7,45.7,17.7
                c1.6,0,3.1-0.1,4.6-0.3c20.4-3.2,26.2-8.1,36.8-24.1C433.9,454.7,435.3,449.4,433.7,445.5z"/>
            <g>
                <path class="st4" d="M357.1,442c5,2.6,5.7-3.8,2.5-6.3c-0.7-0.5-1.6-0.9-2.4-0.9c-0.9,0-1.8,0.4-2.3,1.1c-0.6,0.8-0.6,2-0.3,2.9
                    C354.9,440.2,355.9,441.4,357.1,442z"/>
                <path class="st4" d="M368,443.1c0.8,0.1,1.7,0.1,2.5-0.3c1.4-0.8,1.8-2.7,1.1-4.1c-1.3-2.6-5.4-3.2-6.6-0.2
                    c-0.4,1.2-0.2,2.6,0.7,3.5C366.2,442.6,367.1,443,368,443.1z"/>
                <path class="st4" d="M377.5,446.7c0.8,0.3,1.7,0.3,2.5-0.1c0.8-0.4,1.4-1,1.8-1.8c0.7-1.2,1-2.6,0.4-3.8c-0.4-0.9-1.4-1.6-2.4-1.6
                    c-0.7-0.2-1.5-0.1-2.2,0.1c-0.9,0.4-1.6,1.2-1.9,2.1c-0.3,0.9-0.2,1.9,0.1,2.9C376.1,445.4,376.6,446.3,377.5,446.7z"/>
                <path class="st4" d="M387.6,447.8c1,0.6,2.4,0.5,3.4-0.2c0.8-0.7,1.2-1.8,1.3-2.9c0.2-2.2-0.9-5.4-3.6-5.2c-2.2,0.1-3.2,3.6-3,5.4
                    C385.8,446.1,386.5,447.2,387.6,447.8z"/>
                <path class="st4" d="M401,448c1.5-0.1,2.9-1.2,3.5-2.6c0.6-1.4,0.5-3-0.1-4.4c-0.5-1.1-1.4-2.1-2.5-2.5c-1.2-0.4-2.6,0.1-3.2,1.2
                    l1.9-0.4c-1.5,0.3-2.9,1.5-3.4,3c-0.5,1.3-0.4,2.8,0.4,4C398.3,447.4,399.7,448.1,401,448z"/>
                <path class="st4" d="M411.8,446c1.8-0.8,3.1-2.6,3.1-4.6c0.1-1.8-1.4-4-3.3-2.7c-1.6,1.2-2.6,3.4-2.8,5.4c0,0.6,0,1.2,0.4,1.7
                    C409.9,446.4,411,446.3,411.8,446z"/>
                <path class="st4" d="M423.5,444.8c0.4-0.2,0.8-0.6,1-1c0.4-0.7,0.6-1.6,0.7-2.4c0.4-2.2-0.3-6.4-3.5-4.8c-2.3,1.2-3.2,5.3-1.7,7.3
                    C420.8,444.9,422.3,445.4,423.5,444.8z"/>
                <path class="st4" d="M426.9,446.2c-0.7-0.2-1.4,0-2.1,0.2c-1.6,0.5-3.1,1-4.7,1.5c-0.4-0.8-1.1-1.5-2-1.8
                    c-1.8-0.6-3.7,0.2-5.4,1.1c-4.7-0.1-9.4,1.1-13.9,2.3c-2.1,0.6-4.3,1.1-6.4,1.7c-0.1,0-0.2,0.1-0.3,0.1c-0.4-0.1-0.8-0.1-1.2-0.1
                    c-1.1-0.2-2.3-0.4-3.4-0.2c-0.5,0.1-1,0.3-1.4,0.6c-0.9-1.2-2.4-2-3.8-2.3c-2.4-0.4-4.9,0-7.3-0.7c-2.8-0.8-5-2.9-8.1-3.1
                    c-2.3-0.1-4,0.2-6.2-0.6c-5.1-1.9-10.5-5-16-5.3c-3.9-0.2-6.4,0.3-9.8-2.5c-2.7-2.3-4.6-5.5-6-8.8c-2.4-5.6-3.7-11.7-3.7-17.8
                    c-2.4,1.3-4.9,2.6-7.3,3.9c-6.1-8-12.1-15.9-18.2-23.9c-0.9-1.2-1.9-2.4-3.3-2.8c-2.4-0.7-4.5,1.5-4.9,3.7
                    c-0.5,2.9,1.9,5.5,3.6,7.5c3.1,3.5,6.3,6.6,8.9,10.6c6.6,10.1,10.6,21.9,11.3,34c0.2,4.1,0.4,8.9,3.7,11.4c1.3,1,3,1.5,4.7,2
                    c5.6,1.6,11.2,3.1,16.8,4.7c1.3,0.4,2.7,0.7,3.9,0.5c0.7,0.7,1.3,1.4,2.1,2c3.7,3.1,8.1,5.2,12.4,7.2c6.4,3,12.9,6.1,19.7,7.8
                    c6.9,1.8,14.2,2.2,21,0c6.3-2.1,11.8-6.4,16.2-11.4c4.4-5,7.9-10.8,11.3-16.5C428.1,449.7,428.7,446.9,426.9,446.2z"/>
            </g>
        </g>
        <g class="skull right" id="skull-top">
            <path d="M467,301.3c-4.7-25.2-28.4-72.5-108.3-75.5c-80-3-101.6,40.4-101.6,40.4c-46,37.4-12.3,101.3-12.3,101.3
                c11,42.5,83.5,48.9,83.5,48.9s-7.9-12.6-4.7-14.2c1.4-0.7,7.2-0.5,12.7,1c0.1,2.6,1,5.2,2,7.5c1,2.3,2.4,4.4,4,6.3
                c0.2,0.3,2,1.9,3.5,3.1c-0.6,7.3,5.2,10.4,5.2,10.4c21.1,9.4,60.8,9.5,73.8,4.4c13-5.2,11.6-13.8,11.6-13.8
                c7.6-6.8,7.3-18.2,7-21.2c1.2-0.2,3.8-1.1,9.4-3.3C467.1,390.8,471.8,326.5,467,301.3z"/>
            <g>
                <path class="st4" d="M455.1,286.9c-9.6-22.4-30.2-38.7-52.8-47.7c-13-5.2-27.5-7.5-42.4-7.4c-0.3-0.1-0.7-0.3-1-0.4
                    c-5.1-1.6-12.8,0-18,0.5c-12.6,1.2-25,3.8-37,7.8c-9.2,3.1-18.3,7.1-26,13c-6.3,4.8-11.7,11-15.1,18.2
                    c-23.4,23.9-32.3,56.9-9.9,93.3c-0.9,2.4,2.5,8.8,3.3,10.3c2.9,5.1,6.8,9.5,11.4,13.1c4.3,3.4,9.3,5.9,14.6,7.4
                    c11.4,7.6,24.4,12.9,37.9,15.8c-9.1-6.7-17.3-14.6-24.3-23.5c6.5,4.8,14.8,7,22.9,6.1c1.3,2,5.2,4.3,8.3,4.3c2.8,0,5.4-1.5,7.8-3
                    c2.4-1.4,4.8-2.9,6.8-4.9c1.5-1.4,2.7-3.1,3.4-5c4.2-1.5,8.4-3,12.6-4.5c-2.8,6.1-7.7,11.2-13.6,14.4c-0.6,0.3,7.6,12.9,7.1,21
                    c7.3,2.3,14.8,4,22.5,5c16.4,2.3,33.1,1.8,49.3-1.5c4.9-1,10-2.5,13.2-6.3c3.5-4.2,3.7-10.4,2.2-15.8c-0.3-1.2-8.8-8.1-9.3-9.3
                    c4.4,0.2,17,4.4,20.1,1.4c7.3-6.8,8.8-17.5,10-27.4C462.3,336.8,465.1,310.2,455.1,286.9z M255.4,343.6c1.3,2.8,3.8,4.5,5.8,6.7
                    c2.2,2.4,3.5,5.4,4.9,8.3c2.5,5.5,5.1,10.9,7.6,16.4C261.3,369.4,255.1,356.7,255.4,343.6z M380.9,304.2c1.2-2.7,3.1-5.1,5-7.5
                    c2.4-3,4.9-6.1,8.4-7.4c6-2.3,13,1.6,16.4,7.1c3.1,4.9,7.1,15.7,1.8,20.3c-6.3,5.6-16.6,6.8-24.3,3.7c-3.5-1.4-6.9-3.9-8.1-7.5
                    C379.1,310.1,379.7,306.9,380.9,304.2z M331.3,389.2c-0.9,0.6-1.9,0.9-2.9,1.1c-7.4-4.3-15.3-7.7-23.6-10
                    c-5.5-1.5-11.4-2.8-15.5-6.7c10.3-1.4,21.2,0.9,30,6.4c1.1,0.7,2.6,1.4,3.6,0.6c1.1-0.9,0.4-2.7-0.3-4c-3.1-5.6-5.9-13.7-4.9-20.2
                    c0.1-0.4,0.2-0.8,0.3-1.2c0,0,0,0,0,0l-1.1,0.8c0.7-1.9,1.9-3.6,3.4-4.9c1-1.4,2-2.7,2.7-3.9c2-3.2,3.9-6.5,6-9.7
                    c1.1-1.7,2.1-3.4,2.6-5.4c0.9-3.6-0.3-7.5,0.4-11.1c0.1-0.7,0.4-1.5,0.9-2c-3.1-0.9-6.5-3.2-8.6-4.6c-3.5-2.4-6.5-5.3-9-8.7
                    c-4.6-6.3-7-13.9-10.6-20.8c-1.7-3.2-3.8-6.3-6.3-8.9c-2-2-4.8-3.3-6.6-5.3c3.9-1.6,9.4,2.1,13,3.3c0.5-2.5,0.5-5.1,0.8-7.7
                    c1.8-0.4,3.5,1.3,4,3.1c0.4,1.8-0.1,3.7-0.4,5.5c-2.1,11.8,2.9,24.6,12.5,31.8c4.5,3.4,11.1,6,13.6,11.5c1.2,2.5,1.3,6.4,1.5,9.2
                    c0.3,3.5,0,7.2-1.7,10.4c-1.3,2.5-3.4,4.5-5.4,6.4c-1.8,1.7-3.6,3.5-5.4,5.2c-1.9,10.3-0.6,21.2,3.7,30.8c1.3,2.9,2.9,5.8,3.8,8.8
                    C331.6,388.9,331.5,389.1,331.3,389.2z M376.4,359.8c-3.9,4.6-9.1,8-14.6,10.6c-6.2,3-12.9,5-19.7,6.2c-2.8,0.5-5.8,0.7-8.2-0.7
                    c-4-2.4-4.3-8.1-3.4-12.7c2.6-12.9,11.5-24.1,23-30.3c4.6-2.5,12.5-6.4,17.9-4.7c5.8,1.8,10.3,9.3,10.8,15
                    C382.7,349.1,380.3,355.2,376.4,359.8z M387.4,335.3c1-1.2,5.2-5,6.9-3.5c2.1,1.8-1.7,6.7-3.1,7.8c-1.8,1.5-4.1,2.3-6.4,2.3
                    C384.9,339.5,385.9,337.2,387.4,335.3z M410.9,394.4c-2,0.5-4.1-0.4-5.5-1.9c-1.5-1.4-2.4-3.3-3.3-5.1c-1.4,2.6-2.9,5.3-5.2,7.1
                    s-5.8,2.6-8.3,1c-1.8-1.1-2.8-3.3-3-5.4c-0.2-2.1,0.3-4.2,0.9-6.3c1.8-5.7,9.1-22.6,16.7-21.3c8.2,1.3,12.5,16.9,12.4,23.5
                    C415.6,389.5,414.3,393.6,410.9,394.4z M441.4,369.8c-6.5,4.7-16.3,2.7-22-3s-8-14-8.6-22c-0.4-5.8,0.8-16.2,8.6-16.7
                    c5.3-0.4,13.5,6.1,17.4,9.3c4.9,3.9,9,9.3,10.3,15.4C448.5,359,446.5,366,441.4,369.8z"/>
                <path class="st4" d="M363,422.8c-0.8-0.3-1.7-0.4-2.5-0.1c-1.2,0.5-2,1.8-1.9,3c0.1,0.6,0.3,1.2,0.7,1.7c0.7,0.8,1.7,1.3,2.7,1.3
                    C366,428.9,366.1,424.1,363,422.8z"/>
                <path class="st4" d="M372.3,424.1c-2.2-0.2-3.5,0.6-4.2,2.7c-0.3,1-0.3,2.1,0.3,2.9c0.7,0.9,1.8,1.2,2.9,1.4
                    c0.9,0.2,1.9,0.4,2.7-0.2c0.7-0.5,0.9-1.5,1-2.3c0.2-1,0.3-2.1-0.2-3C374.3,424.7,373.3,424.2,372.3,424.1z"/>
                <path class="st4" d="M385.6,424.2c-0.9-0.4-2.4,0.2-3.3,0.4c-1.3,0.3-2.4,1-3.1,2.1c-1,1.5-0.9,3.6,0.1,5.1c0.4,0.5,0.8,1,1.4,1.3
                    c1.4,0.7,3.1,0.2,4.2-0.9c1.1-1,1.7-2.5,1.9-4c0.1-0.7,0.2-1.5,0-2.3C386.7,425.2,386.3,424.5,385.6,424.2z"/>
                <path class="st4" d="M393.2,423.2c-2.6,0.3-3.4,3.6-3.5,5.8c0,1-0.1,2.1,0.2,3.1c0.3,1,0.9,2,1.8,2.4c1.5,0.8,3.5,0,4.5-1.4
                    c1-1.4,1.4-3.1,1.5-4.8C398.1,425.3,396.5,422.8,393.2,423.2z"/>
                <path class="st4" d="M404.8,424.2c-2.2-0.7-3.3,1.2-4.2,3.1c-0.6,1.2-0.8,2.6-0.5,3.9c0.3,1.3,1.3,2.5,2.5,2.9
                    c1,0.3,2.1,0.1,3-0.3c2.1-1.1,3.3-3.8,2.7-6.1C407.9,426.1,406.5,424.7,404.8,424.2z"/>
                <path class="st4" d="M413.8,424.9c-1.3,1.7-2,7,0.4,8c0.8,0.3,1.7,0.1,2.4-0.4c0.7-0.5,1.2-1.2,1.7-1.9c0.8-1.1,1.6-2.2,1.5-3.6
                    C419.6,424.4,415.5,422.7,413.8,424.9z"/>
                <path class="st4" d="M427,421.1c-2.3,0.7-5.6,7.1-3.5,8.8c0.6,0.5,1.4,0.5,2.1,0.3s1.3-0.7,1.8-1.2c1.3-1.3,3-3.4,3.1-5.4
                    C430.6,421.9,428.8,420.6,427,421.1z"/>
                <path class="st4" d="M341.2,398.1c-1.5,0.2,0.5,7.4,0.8,8.6c0.4,1.6,1,3.2,1.6,4.7c0.4,0.9,2.3,3.5,2.2,4.4
                    c0.4-3.3,0.1-6.6-0.7-9.8C344.8,404.8,343,397.8,341.2,398.1z"/>
            </g>
        </g>
        <polygon class="laser nst1" points="442.5,316 693.6,357.7 695.1,358 696.1,351.8 438.8,309 692.5,308.9 692.5,302.6 444.6,302.7 
            681.9,264.5 680.9,258.3 437.3,297.5 663.5,225.2 665,224.8 663.1,218.8 391.6,305.5 401.7,309.6 401.9,309.6 693.1,403.3 
            694.6,403.8 696.5,397.8 "/>
        <polygon id="laser" class="laser st5" points="421.8,309.8 694.1,354.9 694.6,351.8 420,306.3 691.2,306.1 691.2,303 425.1,303.1 
            680.4,262 679.9,258.9 417,301.2 663.3,222.5 662.3,219.5 396.5,304.5 402.2,306.8 402.3,306.8 409.9,309.2 693.9,400.6 
            694.8,397.6 "/>
        <path class="skull left" id="LEFT-skull-bg" d="M372.3,449.1c-16.8,15.8-40.9,23.6-63.8,20.5c-11.1-1.5-22.4-5.7-29.4-14.4c-6.1-7.6-8.2-17.6-9.3-27.3
            c-2-17.7-1.1-35.8,2.6-53.2c2.1-9.7,5.1-19.4,10.4-27.8c5.3-8.4,13.2-15.5,22.7-18.4c10.6-3.2,22.2-1.1,32.6,2.7
            c19.6,7.1,37,19.9,50,36.3c5.4,6.8,10.9,14,10.3,23c-0.6,9.2-3.1,19.6-6.3,28.2C388,430.2,381.2,440.7,372.3,449.1z"/>
        <g class="skull left" id="LEFT-skull-bot">
            <path d="M268.9,447.4c0.9-2.1,2.4-3.2,3.7-3.8c-0.5-1.8-0.9-4.9,0.8-7.1c1.8-2.3,5.2-2.9,10.2-2c12.4,2.4,27.7,5.3,66.5-3.2
                l0.4-0.1l0.4,0.1c0.5,0.2,4.6,1.6,5.9,4.4c0.2,0.4,0.3,0.9,0.3,1.3c1.8,0.1,4.9,0,7.8-1.9c3.2-2.1,5.2-5.8,6.2-11l3.5-19.2l8.6,3.4
                l16.6-21.1l0.2-0.2c0.2-0.2,5.4-4.7,10.5-3.7c2.6,0.5,4.7,2.4,6.2,5.4l0.1,0.2c1.1,3.5,1.5,11.3-4.8,15.2
                c-6.7,4.1-21.8,30.1-18.9,48.3c0.4,1.3,0.7,6.5-13.6,11.3c-12.6,4.2-18,6-19.1,6.3c-2.6,1.7-26.8,17.7-45.7,17.7
                c-1.6,0-3.1-0.1-4.6-0.3c-20.4-3.2-26.2-8.1-36.8-24.1C268.7,456.6,267.3,451.3,268.9,447.4z"/>
            <g>
                <path class="st4" d="M345.5,443.9c-5,2.6-5.7-3.8-2.5-6.3c0.7-0.5,1.6-0.9,2.4-0.9c0.9,0,1.8,0.4,2.3,1.1c0.6,0.8,0.6,2,0.3,2.9
                    C347.6,442.1,346.7,443.3,345.5,443.9z"/>
                <path class="st4" d="M334.6,445c-0.8,0.1-1.7,0.1-2.5-0.3c-1.4-0.8-1.8-2.7-1.1-4.1c1.3-2.6,5.4-3.2,6.6-0.2
                    c0.4,1.2,0.2,2.6-0.7,3.5C336.3,444.5,335.5,444.9,334.6,445z"/>
                <path class="st4" d="M325,448.6c-0.8,0.3-1.7,0.3-2.5-0.1c-0.8-0.4-1.4-1-1.8-1.8c-0.7-1.2-1-2.6-0.4-3.8c0.4-0.9,1.4-1.6,2.4-1.6
                    c0.7-0.2,1.5-0.1,2.2,0.1c0.9,0.4,1.6,1.2,1.9,2.1c0.3,0.9,0.2,1.9-0.1,2.9C326.5,447.3,325.9,448.2,325,448.6z"/>
                <path class="st4" d="M315,449.7c-1,0.6-2.4,0.5-3.4-0.2c-0.8-0.7-1.2-1.8-1.3-2.9c-0.2-2.2,0.9-5.4,3.6-5.2c2.2,0.1,3.2,3.6,3,5.4
                    C316.7,448,316.1,449.1,315,449.7z"/>
                <path class="st4" d="M301.5,449.9c-1.5-0.1-2.9-1.2-3.5-2.6c-0.6-1.4-0.5-3,0.1-4.4c0.5-1.1,1.4-2.1,2.5-2.5
                    c1.2-0.4,2.6,0.1,3.2,1.2l-1.9-0.4c1.5,0.3,2.9,1.5,3.4,3c0.5,1.3,0.4,2.8-0.4,4C304.3,449.3,302.9,450,301.5,449.9z"/>
                <path class="st4" d="M290.8,447.9c-1.8-0.8-3.1-2.6-3.1-4.6c-0.1-1.8,1.4-4,3.3-2.7c1.6,1.2,2.6,3.4,2.8,5.4c0,0.6,0,1.2-0.4,1.7
                    C292.7,448.3,291.6,448.2,290.8,447.9z"/>
                <path class="st4" d="M279.1,446.6c-0.4-0.2-0.8-0.6-1-1c-0.4-0.7-0.6-1.6-0.7-2.4c-0.4-2.2,0.3-6.4,3.5-4.8
                    c2.3,1.2,3.2,5.3,1.7,7.3C281.8,446.8,280.2,447.3,279.1,446.6z"/>
                <path class="st4" d="M275.7,448.1c0.7-0.2,1.4,0,2.1,0.2c1.6,0.5,3.1,1,4.7,1.5c0.4-0.8,1.1-1.5,2-1.8c1.8-0.6,3.7,0.2,5.4,1.1
                    c4.7-0.1,9.4,1.1,13.9,2.3c2.1,0.6,4.3,1.1,6.4,1.7c0.1,0,0.2,0.1,0.3,0.1c0.4-0.1,0.8-0.1,1.2-0.1c1.1-0.2,2.3-0.4,3.4-0.2
                    c0.5,0.1,1,0.3,1.4,0.6c0.9-1.2,2.4-2,3.8-2.3c2.4-0.4,4.9,0,7.3-0.7c2.8-0.8,5-2.9,8.1-3.1c2.3-0.1,4,0.2,6.2-0.6
                    c5.1-1.9,10.5-5,16-5.3c3.9-0.2,6.4,0.3,9.8-2.5c2.7-2.3,4.6-5.5,6-8.8c2.4-5.6,3.7-11.7,3.7-17.8c2.4,1.3,4.9,2.6,7.3,3.9
                    c6.1-8,12.1-15.9,18.2-23.9c0.9-1.2,1.9-2.4,3.3-2.8c2.4-0.7,4.5,1.5,4.9,3.7c0.5,2.9-1.9,5.5-3.6,7.5c-3.1,3.5-6.3,6.6-8.9,10.6
                    c-6.6,10.1-10.6,21.9-11.3,34c-0.2,4.1-0.4,8.9-3.7,11.4c-1.3,1-3,1.5-4.7,2c-5.6,1.6-11.2,3.1-16.8,4.7c-1.3,0.4-2.7,0.7-3.9,0.5
                    c-0.7,0.7-1.3,1.4-2.1,2c-3.7,3.1-8.1,5.2-12.4,7.2c-6.4,3-12.9,6.1-19.7,7.8c-6.9,1.8-14.2,2.2-21,0c-6.3-2.1-11.8-6.4-16.2-11.4
                    c-4.4-5-7.9-10.8-11.3-16.5C274.5,451.6,273.8,448.8,275.7,448.1z"/>
            </g>
        </g>
        <g class="skull left" id="LEFT-skull-top">
            <path d="M235.5,303.2c4.7-25.2,28.4-72.5,108.3-75.5c80-3,101.6,40.4,101.6,40.4c46,37.4,12.3,101.3,12.3,101.3
                c-11,42.5-83.5,48.9-83.5,48.9s7.9-12.6,4.7-14.2c-1.4-0.7-7.2-0.5-12.7,1c-0.1,2.6-1,5.2-2,7.5c-1,2.3-2.4,4.4-4,6.3
                c-0.2,0.3-2,1.9-3.5,3.1c0.6,7.3-5.2,10.4-5.2,10.4c-21.1,9.4-60.8,9.5-73.8,4.4c-13-5.2-11.6-13.8-11.6-13.8
                c-7.6-6.8-7.3-18.2-7-21.2c-1.2-0.2-3.8-1.1-9.4-3.3C235.5,392.6,230.8,328.4,235.5,303.2z"/>
            <g>
                <path class="st4" d="M243.2,363.9c1.2,9.9,2.8,20.6,10,27.4c3.2,3,15.8-1.3,20.1-1.4c-0.5,1.2-8.9,8-9.3,9.3
                    c-1.5,5.3-1.3,11.5,2.2,15.8c3.2,3.8,8.4,5.3,13.2,6.3c16.2,3.3,33,3.8,49.3,1.5c7.6-1.1,15.1-2.8,22.5-5
                    c-0.5-8.1,7.7-20.7,7.1-21c-5.9-3.2-10.7-8.4-13.6-14.4c4.2,1.5,8.4,3,12.6,4.5c0.7,1.9,2,3.6,3.4,5c2,1.9,4.4,3.4,6.8,4.9
                    c2.4,1.5,5,3,7.8,3c3,0,6.9-2.2,8.3-4.3c8,1,16.4-1.2,22.9-6.1c-7,8.8-15.2,16.7-24.3,23.5c13.4-2.9,26.4-8.2,37.9-15.8
                    c5.3-1.4,10.3-4,14.6-7.4c4.6-3.6,8.5-8,11.4-13.1c0.9-1.5,4.2-8,3.3-10.3c22.4-36.4,13.6-69.4-9.9-93.3
                    c-3.3-7.2-8.7-13.4-15.1-18.2c-7.7-5.9-16.8-9.9-26-13c-12-4-24.4-6.6-37-7.8c-5.2-0.5-12.9-2.1-18-0.5c-0.3,0.1-0.7,0.2-1,0.4
                    c-14.8-0.1-29.3,2.2-42.4,7.4c-22.6,9-43.2,25.4-52.8,47.7C237.4,312.1,240.2,338.6,243.2,363.9z M428.9,376.9
                    c2.5-5.5,5.1-10.9,7.6-16.4c1.4-2.9,2.7-5.9,4.9-8.3c2-2.2,4.5-4,5.8-6.7C447.5,358.6,441.3,371.3,428.9,376.9z M322.5,314.8
                    c-1.2,3.6-4.6,6.1-8.1,7.5c-7.6,3.1-18,1.9-24.3-3.7c-5.3-4.7-1.2-15.4,1.8-20.3c3.4-5.5,10.3-9.3,16.4-7.1
                    c3.5,1.3,6.1,4.4,8.4,7.4c1.9,2.3,3.7,4.7,5,7.5C322.9,308.8,323.4,312,322.5,314.8z M370.8,390.7c1-3,2.5-5.9,3.8-8.8
                    c4.3-9.6,5.6-20.5,3.7-30.8c-1.8-1.7-3.6-3.5-5.4-5.2c-2-1.9-4.1-3.9-5.4-6.4c-1.7-3.2-1.9-6.9-1.7-10.4c0.2-2.8,0.3-6.6,1.5-9.2
                    c2.6-5.4,9.1-8.1,13.6-11.5c9.6-7.2,14.6-20,12.5-31.8c-0.3-1.8-0.8-3.7-0.4-5.5c0.4-1.8,2.2-3.5,4-3.1c0.2,2.5,0.3,5.2,0.8,7.7
                    c3.6-1.2,9.1-4.9,13-3.3c-1.8,2-4.7,3.2-6.6,5.3c-2.5,2.6-4.6,5.7-6.3,8.9c-3.7,6.9-6.1,14.5-10.6,20.8c-2.5,3.4-5.5,6.4-9,8.7
                    c-2.1,1.4-5.6,3.8-8.6,4.6c0.5,0.5,0.7,1.3,0.9,2c0.7,3.7-0.5,7.5,0.4,11.1c0.5,1.9,1.6,3.7,2.6,5.4c2.1,3.2,4,6.5,6,9.7
                    c0.7,1.2,1.8,2.5,2.7,3.9c1.5,1.3,2.7,3,3.4,4.9l-1.1-0.8c0,0,0,0,0,0c0.1,0.4,0.2,0.8,0.3,1.2c1,6.5-1.8,14.6-4.9,20.2
                    c-0.7,1.3-1.4,3.1-0.3,4c1,0.8,2.5,0.1,3.6-0.6c8.9-5.5,19.7-7.9,30-6.4c-4.1,4-10,5.2-15.5,6.7c-8.3,2.3-16.2,5.7-23.6,10
                    c-1-0.2-2-0.5-2.9-1.1C371.1,390.9,371,390.8,370.8,390.7z M320.4,345c0.5-5.7,5-13.2,10.8-15c5.4-1.7,13.2,2.1,17.9,4.7
                    c11.4,6.3,20.4,17.4,23,30.3c0.9,4.6,0.6,10.3-3.4,12.7c-2.4,1.4-5.5,1.2-8.2,0.7c-6.8-1.1-13.4-3.2-19.7-6.2
                    c-5.5-2.6-10.7-5.9-14.6-10.6C322.3,357.1,319.8,351,320.4,345z M317.8,343.8c-2.3,0-4.6-0.8-6.4-2.3c-1.3-1.1-5.2-6-3.1-7.8
                    c1.7-1.4,5.9,2.3,6.9,3.5C316.7,339.1,317.6,341.4,317.8,343.8z M287,388c-0.1-6.6,4.2-22.2,12.4-23.5
                    c7.7-1.2,14.9,15.6,16.7,21.3c0.6,2,1.1,4.2,0.9,6.3c-0.2,2.1-1.2,4.2-3,5.4c-2.5,1.6-6,0.8-8.3-1c-2.3-1.8-3.8-4.5-5.2-7.1
                    c-0.9,1.8-1.8,3.7-3.3,5.1c-1.5,1.4-3.6,2.3-5.5,1.9C288.3,395.5,287,391.4,287,388z M255.4,354.7c1.3-6.2,5.4-11.5,10.3-15.4
                    c3.9-3.1,12.1-9.6,17.4-9.3c7.8,0.6,9,11,8.6,16.7c-0.6,8-2.9,16.3-8.6,22s-15.5,7.7-22,3C256,367.9,254.1,360.9,255.4,354.7z"/>
                <path class="st4" d="M339.5,424.7c0.8-0.3,1.7-0.4,2.5-0.1c1.2,0.5,2,1.8,1.9,3c-0.1,0.6-0.3,1.2-0.7,1.7
                    c-0.7,0.8-1.7,1.3-2.7,1.3C336.5,430.8,336.4,426,339.5,424.7z"/>
                <path class="st4" d="M330.3,426c2.2-0.2,3.5,0.6,4.2,2.7c0.3,1,0.3,2.1-0.3,2.9c-0.7,0.9-1.8,1.2-2.9,1.4
                    c-0.9,0.2-1.9,0.4-2.7-0.2c-0.7-0.5-0.9-1.5-1-2.3c-0.2-1-0.3-2.1,0.2-3C328.2,426.6,329.3,426.1,330.3,426z"/>
                <path class="st4" d="M317,426.1c0.9-0.4,2.4,0.2,3.3,0.4c1.3,0.3,2.4,1,3.1,2.1c1,1.5,0.9,3.6-0.1,5.1c-0.4,0.5-0.8,1-1.4,1.3
                    c-1.4,0.7-3.1,0.2-4.2-0.9c-1.1-1-1.7-2.5-1.9-4c-0.1-0.7-0.2-1.5,0-2.3C315.9,427.1,316.3,426.4,317,426.1z"/>
                <path class="st4" d="M309.4,425.1c2.6,0.3,3.4,3.6,3.5,5.8c0,1,0.1,2.1-0.2,3.1c-0.3,1-0.9,2-1.8,2.4c-1.5,0.8-3.5,0-4.5-1.4
                    c-1-1.4-1.4-3.1-1.5-4.8C304.4,427.2,306.1,424.7,309.4,425.1z"/>
                <path class="st4" d="M297.7,426.1c2.2-0.7,3.3,1.2,4.2,3.1c0.6,1.2,0.8,2.6,0.5,3.9c-0.3,1.3-1.3,2.5-2.5,2.9
                    c-1,0.3-2.1,0.1-3-0.3c-2.1-1.1-3.3-3.8-2.7-6.1C294.7,427.9,296.1,426.6,297.7,426.1z"/>
                <path class="st4" d="M288.8,426.8c1.3,1.7,2,7-0.4,8c-0.8,0.3-1.7,0.1-2.4-0.4c-0.7-0.5-1.2-1.2-1.7-1.9c-0.8-1.1-1.6-2.2-1.5-3.6
                    C282.9,426.3,287.1,424.6,288.8,426.8z"/>
                <path class="st4" d="M275.6,423c2.3,0.7,5.6,7.1,3.5,8.8c-0.6,0.5-1.4,0.5-2.1,0.3c-0.7-0.2-1.3-0.7-1.8-1.2
                    c-1.3-1.3-3-3.4-3.1-5.4C272,423.8,273.8,422.5,275.6,423z"/>
                <path class="st4" d="M361.4,400c1.5,0.2-0.5,7.4-0.8,8.6c-0.4,1.6-1,3.2-1.6,4.7c-0.4,0.9-2.3,3.5-2.2,4.4
                    c-0.4-3.3-0.1-6.6,0.7-9.8C357.7,406.7,359.6,399.7,361.4,400z"/>
            </g>
        </g>
    </svg>
</div>
</template>

<script>
export default {
  name: 'badge-2',
  data() {
    return {
            counter: 0,
            intervalId: null,
            doAnimate: false
        }
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.doAnimate = true
            
            setTimeout(() => {
                this.doAnimate = false
            }, 8000)
        }, 15000)

        this.doAnimate = true
        setTimeout(() => {
            this.doAnimate = false
        }, 5000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style scoped>
.st0{fill:#EFEFF8;}
.st1{fill:#1D1D1D;}
.st2{fill:#F2F1FA;}
.st3{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}
.st4{fill:#FFFFFF;}
.st5{fill:#5639EF;}

.remote-viewers svg {
    transform: scale(1.05); /* slightly smaller than other badges so this fixes it */
}

.remote-viewers * {
    transition: all 0.2;
}

.remote-viewers .skull.right {
    opacity: 0;
}

.remote-viewers.animate .skull.right,
.remote-viewers:hover .skull.right {
    opacity: 1;
}

.remote-viewers .skull.left {
    fill: red;
    opacity: 1;
}

.remote-viewers #LEFT-skull-bg {
    opacity: 0;
}

.remote-viewers.animate .skull.left,
.remote-viewers:hover .skull.left {
    opacity: 0;
}

.remote-viewers.animate .st3,
.remote-viewers:hover .st3 {
    stroke-width: 7px;
    stroke: #EA1313;
}

@keyframes flicker {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes dash {
  to {
    stroke-dashoffset: 1000;
    stroke-width: 3px;
  }
}

.remote-viewers.animate .laser,
.remote-viewers:hover .laser {
    animation-name: flicker;
    animation-duration: 0.5s;
    animation-iteration-count: infinite;
}

.remote-viewers.animate .star,
.remote-viewers:hover .star {
    animation: flicker 2s;
    animation-iteration-count: infinite;
}

.remote-viewers:hover .laser, .star, .left, .laser {
    opacity: 0;
}

#grid {
    opacity: 0.2;
}

.remote-viewers.animate .laser,
.remote-viewers:hover .laser {
    opacity: 1;
}

@keyframes jaw {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(20px);
    }
    60% {
        transform: translateY(0);
    }
}

.remote-viewers.animate .right#skull-bot,
.remote-viewers:hover .right#skull-bot {
    animation: jaw 5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.remote-viewers.animate #grid,
.remote-viewers:hover #grid {
    opacity: 1;
    stroke-dasharray: 10;
    animation: dash 50s linear infinite;
}

.remote-viewers.animate .skull.left,
.remote-viewers:hover .skull.left {
    display: none;
} 

</style>
